export default __webpack_public_path__ + "static/media/file-medical-alt.fbffaffb.svg";